import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root(t) {
    var legacyPaddingRight = parseFloat(t.menuHeaderLegacyPaddingRight);
    var paddingRight = legacyPaddingRight !== 0 ? parseFloat(t.menuHeaderPaddingX) + legacyPaddingRight + "px" : t.menuHeaderPaddingX;
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      color: ", ";\n      cursor: default;\n      font-size: ", ";\n      line-height: ", ";\n      padding: ", " ", " ", " ", ";\n    "])), t.menuHeaderColor, t.menuHeaderFontSize, t.menuHeaderLineHeight, t.menuHeaderPaddingTop, paddingRight, t.menuHeaderPaddingBottom, t.menuHeaderPaddingX);
  },
  withLeftPadding: function withLeftPadding(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      padding-left: ", ";\n    "])), t.menuItemPaddingForIcon);
  }
});